export class PageChangedEvent {

    moveToPage = 0;
    turnForward: boolean;
    turnBackwards: boolean;
    isRealPageNumber = false;

    static createTurnPageBackwardsEvent(): PageChangedEvent {
        const pageChangedEvent = new PageChangedEvent();
        pageChangedEvent.turnBackwards = true;

        return pageChangedEvent;
    }

    static createTurnPageForwardEvent(): PageChangedEvent {
        const pageChangedEvent = new PageChangedEvent();
        pageChangedEvent.turnForward = true;

        return pageChangedEvent;
    }

}
